export class JWTAuthRequest {
  username: string;
  password: string;
  
  constructor(username: string, password: string){
      this.username = username;
      this.password = password;
  }
  
}

export class JwtAuthResponse {
  jwttoken: string;
  loggedUserType: string;

  loggedUserIdentity: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };

}